/**
 * API utility functions
 */
export class APIUtils {
  /**
   * Make a GET request
   * @param {string} url
   * @param {Object} options
   * @returns {Promise<any>}
   */
  static async get(url, options = {}) {
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        ...options.headers,
      },
      ...options,
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const contentType = response.headers.get('content-type');
    if (contentType && contentType.includes('application/json')) {
      return response.json();
    } else {
      return response.text();
    }
  }

  /**
   * Make a POST request
   * @param {string} url
   * @param {Object} data
   * @param {Object} options
   * @returns {Promise<any>}
   */
  static async post(url, data = {}, options = {}) {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        ...options.headers,
      },
      body: JSON.stringify(data),
      ...options,
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const contentType = response.headers.get('content-type');
    if (contentType && contentType.includes('application/json')) {
      return response.json();
    } else {
      return response.text();
    }
  }

  /**
   * Get URL parameter value
   * @param {string} name
   * @returns {string|null}
   */
  static getURLParameter(name) {
    const urlParams = new URLSearchParams(window.location.search);
    const value = urlParams.get(name);
    return value === 'null' ? '' : value;
  }

  /**
   * Build URL with parameters
   * @param {string} baseUrl
   * @param {Object} params
   * @returns {string}
   */
  static buildURL(baseUrl, params = {}) {
    const url = new URL(baseUrl, window.location.origin);
    Object.keys(params).forEach((key) => {
      if (params[key] !== null && params[key] !== undefined) {
        url.searchParams.append(key, params[key]);
      }
    });
    return url.toString();
  }
}
